<template>
      <el-upload
        class="upload-demo upload-table"
        action="/api/file"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        multiple
        :limit="limit"
        :on-exceed="handleExceed"
        :show-file-list="false"
        :file-list="fileList">

        <slot></slot>

      </el-upload>
</template>

<script>
    import { downLoadFile,getFileInfo} from "@/api/user/user.js";
    import { savePublicEmp,uploadAttachMent} from "@/api/wage/attachmentManage.js";
    import { downloadFile } from '@/util/util';
    import { mapGetters } from 'vuex';
    export default {
        name: "sbsp-form-file-upload",
        props: {
          limit: {
              type: Number,
              default: 1,
          },
          allSelection:{
              type: Boolean,
              default: false,
          },
          empId:{
            type:String,
            default:''
          },
          fileIds:{
            type:Array,
            default:()=>{
               return []
            }
          },
          fileNames:{
            type:String,
            default:''
          },
          specialType:{
              type:Boolean,
              default:false
          },
          batchId:{
            type:Number,
            default:0
          },
        },
        computed: {
            headers() {
                return {
                    Authorization: `Bearer ${this.accessToken}`,
                };
            },
            ...mapGetters(['accessToken'])
        },
        data(){
            return{
                fileList:[],
            }
        },
      created(){
          console.log(this.fileIds)
          if(this.fileIds.length>0){
            //  let split = this.fileIds.split(",");
            // for (let i = 0; i < split.length; i++) {
            //   downLoadFile(split[i]).then(res=>{
            //   });
            // }

          }
      },
        methods:{
            handlePreview(file) {

                let id = file.response.fileId
                downLoadFile(id).then(res => {
                    console.log(res)
                    downloadFile(res)
                })
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            // 上传前处理
            beforeUpload(file) {

                const isLt10M = file.size / 1024 / 1024 < 10;
                const AllUpExt = ".zip|.jpg|.png|.rar|.7z|";
                const extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                // 护网安全要求，文件做限制，
                let type = ".xls, .zip, .html, .pdf, .xlsx, .ofd, .xml, .png, .jpg, .docx, .doc, .eml, .7z, .jpeg, .msg, .bmp, .txt, .tif, .rar, .jfif, .pptx";
                if(type.indexOf(extName) == "-1"){
                  this.$message.error("不允许上传"+extName+"格式的文件");
                  return false;
                }
                if (!isLt10M) {
                    this.$message.error('上传文件大小不能超过 10MB!');
                    return isLt10M;
                }
                // if (isLt10M) {
                //      this.$Loading.full();
                // }
                //只可以上传 doc/docx/xls/xlsx/pdf 文档格式
                if(this.specialType){
                    if(AllUpExt.indexOf(extName + "|") == "-1"){
                        this.$message.error("只允许上传png、jpg、rar、zip、7z格式的文件");
                        return false;
                    }
                }
                this.$Loading.full();
                return true;
            },
            // 上传成功处理
            handleUploadSuccess(res, file,fileList) {
//              for (let i = 0,l=fileList.length; i <l; i++) {
//                if(i<(l-1)){
//                  this.fileIds +=fileList[i].response.fileId+",";
//                  this.fileNames +=fileList[i].response.fileName+",";
//                }else {
//                  this.fileIds +=fileList[i].response.fileId;
//                  this.fileNames +=fileList[i].response.fileName;
//
//                }
//              }
                this.$Loading.close();
                if (res.fileId) {
//                  this.$emit('update:fileIds', this.fileIds)
//                  this.$emit('update:fileNames', this.fileNames)
                  if(this.allSelection){
                    if(this.fileIds.length==0){
                      this.$message.error('请选择至少一条数据！');
                      return;
                    }
                    let owner = '';
                    this.fileIds.map((item) =>{
                      owner = owner+item.name+ '、'
                    })
                    owner = owner.substring(0,owner.length-2);
                    res.owner = owner;
                    let param =[];
                    this.fileIds.map((item) =>{
                      let obj={
                        empId:item.empId,
                        batchId:item.batchId,
                        fileName:res.fileName,
                        fileId:res.fileId
                      };
                      param.push(obj);
                      item.fileIds.push(res);
                    })
                    savePublicEmp(param).then(res => {
                      console.log("保存公用附件返回的res",res);
                    })
                    this.$emit("refushAttachment");
                  }else{
                    let param ={
                      empId:this.empId,
                      batchId:this.batchId,
                      fileName:res.fileName,
                      fileId:res.fileId
                    };
                    uploadAttachMent(param).then(res => {
                      console.log(res)
                    })
                    console.log(this.fileIds)
                    this.fileIds.push(res);
                  }
                  this.$message.success('上传成功');
                  this.$emit("refushAttachment");
                } else{
                   this.$message.error(res.message);
                }
                this.$forceUpdate();
            },
            // 上传失败处理
            handleUploadError(res, file) {
                const { errorMsg, errorCode } = res;
                if (errorCode === 1) {
                    this.$message.error('上传失败，请检查文件格式是否正确');
                } else {
                    this.$message.error('连接服务器出错，请稍后重试');
                    this.$Loading.close();
                }
            },
        }
    }
</script>

<style scoped lang="scss">
  .el-upload__tip{
    margin-left: 20px;
  }

  .upload-demo{
    display: inline-block;
  }
  .el-upload-list--text{
    display:none;
  }
</style>
